"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonObject = exports.isJson = void 0;
const zod_1 = require("zod");
// === JSON literal ===
const JsonLiteralSchema = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
const JsonSchema = zod_1.z.lazy(() => zod_1.z.union([JsonLiteralSchema, zod_1.z.array(JsonSchema), zod_1.z.record(JsonSchema)]));
const isJson = (data) => JsonSchema.safeParse(data).success;
exports.isJson = isJson;
// === JSON Object ===
const JsonObjectSchema = zod_1.z.record(JsonSchema);
const isJsonObject = (v) => JsonObjectSchema.safeParse(v).success;
exports.isJsonObject = isJsonObject;
//# sourceMappingURL=json.js.map